// extracted by css-extract-rspack-plugin
export default {"socialLink":"_3db24a46","socialTooltip":"_b82e5713","socialIcon":"_47fe9b0d","reportWrapper":"_b70ce280","flagIcon":"_cf812bda"};